export default __webpack_public_path__ + "static/media/pub3-promoting.33b08f92.png";